import React from 'react';

export default props => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" {...props}>
    <path
      fill="currentColor"
      d="M22,14v-1c0-2.21-1.79-4-4-4s-4,1.79-4,4v1h-2v7c0,1.65,1.35,3,3,3h6c1.65,0,3-1.35,3-3v-7h-2Zm-6-1c0-1.1,.9-2,2-2s2,.9,2,2v1h-4v-1Zm3,7h-2v-2h2v2ZM12.41,5h4.59v2.09c-2.51,.42-4.49,2.4-4.92,4.91h-2.08V7.41l2.41-2.41Zm-2.31,17H0V3C0,1.35,1.35,0,3,0H19c1.65,0,3,1.35,3,3v5.54s0,0-.01,0c-.82-.74-1.85-1.25-2.99-1.44V3h-7.41l-3.59,3.59v7.41h2v3H5V6.09l3.23-3.09H3V19h7v2c0,.34,.04,.68,.1,1Z"
    />
  </svg>
);



// WEBPACK FOOTER //
// ./app/icons/safe-icon.jsx